import { render, staticRenderFns } from "./AuthCheckInbox.vue?vue&type=template&id=618a2416&scoped=true"
import script from "./AuthCheckInbox.vue?vue&type=script&lang=js"
export * from "./AuthCheckInbox.vue?vue&type=script&lang=js"
import style0 from "./AuthCheckInbox.vue?vue&type=style&index=0&id=618a2416&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618a2416",
  null
  
)

export default component.exports